export const SET_SHOPEE_UI_FLAG = 'SET_SHOPEE_UI_FLAG';
export const GET_ORDERS = 'GET_ORDERS';
export const GET_VOUCHERS = 'GET_VOUCHERS';
export const SEARCH_PRODUCTS = 'SEARCH_PRODUCTS';
export const SEND_ORDER_MESSAGE = 'SEND_ORDER_MESSAGE';
export const SEND_VOUCHER_MESSAGE = 'SEND_VOUCHER_MESSAGE';
export const SEND_PRODUCT_MESSAGE = 'SEND_PRODUCT_MESSAGE';
